import { Tippy } from 'vue-tippy'

export default {
    props: {
        value: { type: [String, Number], default: null },
        label: { type: String, default: null },
        name: { type: String, default: '' },
        type: { type: String, default: 'text' },
        placeholder: { type: String, default: '' },
        boxClass: { type: String },
        limit: { type: Number, default: null },
        focusedClass: { type: Array, default: null },
        disabled: { type: Boolean, default: false },
        hideError: { type: Boolean, default: false },
        canFoucs: { type: Boolean, default: false },
        errorName: { type: [Boolean, String], default: false },
        afterValue: { type: [Function, String], default: null },
        spaceAfterValue: { type: Boolean, default: true },
        ai: { type: [Boolean, Object], default: false },
        aiName: { type: [String], default: null },
        errorScrollTo: { type: [String, Boolean], default: false },
        autocomplete: { type: String, default: 'off' }
    },

    emits: ['update:value', 'clear', 'focus', 'blur'],

    data() {
        return {
            isFocused: false,
            inputIsFocused: false,
        }
    },

    methods: {
        update(event) {
            this.$emit('update:value', event.target.value, event)
        },

        clear(newValue = null) {
            this.$emit('update:value', newValue)

            setTimeout(() => {
                this.$emit('clear')
            })
        },

        f(e) {
            console.log('focus', e)
            this.isFocused = true
        },

        b(event) {
            console.log('blur', event)
            this.$emit('update:value', event.target.value)
            event.preventDefault()
            this.isFocused = false
        },

        inputFocused(event) {
            this.inputIsFocused = true
            // console.log('inputFocused')

            // // document.activeElement.scrollIntoView()

            // let bounding = document.activeElement.getBoundingClientRect();
            // // console.log('bounding', bounding)

            // // console.log(window.pageYOffset)

            // // if (! (
            // // 	bounding.top >= 0 &&
            // // 	bounding.left >= 0 &&
            // // 	bounding.right <= (window.innerWidth || document.documentElement.clientWidth) &&
            // // 	bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
            // // )) {
            // // 	// errors[0].scrollIntoView();

            // // 	console.log('top', document.activeElement.getBoundingClientRect().top + window.pageYOffset)

            // console.log('window.pageYOffset', window.pageYOffset)
            // console.log('new top', document.activeElement.getBoundingClientRect().top - 32)

            // 	window.scrollTo({
            // 		top: window.pageYOffset + (document.activeElement.getBoundingClientRect().top - 32),
            // 		// top: document.activeElement.getBoundingClientRect().top,
            // 		behavior: 'smooth'
            // 	});
            // // }

            this.$emit('focus', event)
        },

        inputBlur(event) {
            this.inputIsFocused = false
            this.$emit('blur', event)
        },

        setAIValue(value) {
            this.$emit('update:value', value)
        },
    },

    computed: {
        error() {
            // if (this.hideError) {
            // 	return false
            // }

            let inputForm = this.$help.getComponent(this, 'InputForm')

            return inputForm != null ? inputForm.$data.errors.has(this.errorName != false ? this.errorName : this.name) : false
        },

        valueLength() {
            return this.value.length
        },

        aiKey() {
            return this.aiName != null ? this.aiName : this.name
        },
    },

    components: [Tippy],
}
